// @flow
import * as React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import Loader from '~/components/routing/loader';
import { LoadTransition } from '~/components/widgets';

import loadBundle from '../async-loader';

type Props = {
    entry: string
};

type Context = {
    store: Object
};

const AsyncRoute = ({ entry, ...rest }: Props, { store }: Context) => {
    return (
        <Route
            {...rest}
            render={props => (
                <LoadTransition transitionKey={entry}>
                    <Loader entry={entry} {...rest} {...props} load={() => loadBundle(entry, store)} />
                </LoadTransition>
            )}
        />
    );
};

AsyncRoute.contextTypes = { store: PropTypes.object };

export default AsyncRoute;



// WEBPACK FOOTER //
// ./src/routes/async-route/index.js